import DataSelect from "@/components/common/select/DataSelect";
import type { simulationSelectorProps } from "./types.props";

const SimulationSelector: React.FC<simulationSelectorProps> = ({
    simulations,
    selectedId,
    isLoading,
    className,
    onChange,
}) => {
    const options = simulations.map((sim) => ({
        value: sim.id,
        label: sim.name,
    }));

    return (
        <div className={className}>
            <DataSelect
                id="simulation-selector"
                name="simulation"
                options={options}
                value={selectedId}
                onChange={(e) => onChange(e.target.value)}
                disabled={isLoading || simulations.length === 0}
                placeholder={isLoading ? "Cargando..." : "Selecciona una simulación"}
                variant="header"
            />
        </div>
    );
};

export default SimulationSelector;
